import { shouldRenderDetectionStatusChange } from './shouldRenderDetectionStatusChange';

interface GetDetectionStatusUpdateInput {
    /**
     * Array of {@link ManageDetectionsStatusChange} objects
     */
    detectionHistory?: ManageDetectionsStatusChange[] | null;
    /**
     * When true, restrict the search to elements where `.draft === true`
     * @defaultValue false
     */
    draftOnly?: boolean;
    /**
     * When true, restrict the search to elements where `.draft !== true`
     * @defaultValue false
     */
    nonDraftOnly?: boolean;
}

/**
 * Return the last element of an array of ManageDetectionsStatusChange elements where the element
 * should be rendered in the UI. If none is found, return null.
 * @param input - {@link GetDetectionStatusUpdateInput}
 * @returns the last status change that should be rendered in the UI which also matches the
 * `draftOnly` and `nonDraftOnly` conditions, if any are specified.
 */
export const getDetectionStatusUpdate = ({
    detectionHistory,
    draftOnly = false,
    nonDraftOnly = false,
}: GetDetectionStatusUpdateInput): ManageDetectionsStatusChange | null => {
    const lastStatusChange =
        detectionHistory === null || detectionHistory === undefined
            ? null
            : [...detectionHistory]
                  .reverse()
                  .find(
                      (statusChange: ManageDetectionsStatusChange): boolean => {
                          if (
                              !shouldRenderDetectionStatusChange(statusChange)
                          ) {
                              return false;
                          }

                          const isDraft = statusChange?.draft ?? false;

                          if (draftOnly && !isDraft) {
                              return false;
                          }

                          if (nonDraftOnly && isDraft) {
                              return false;
                          }

                          return true;
                      },
                  ) ?? null;

    return lastStatusChange;
};
